// extracted by mini-css-extract-plugin
export var errorBackground = "singleLineForm-module--errorBackground--0f5df";
export var formContainer = "singleLineForm-module--formContainer--19e54";
export var getStartedButton = "singleLineForm-module--getStartedButton--9451e";
export var inputAndButtonContainer = "singleLineForm-module--inputAndButtonContainer--cc930";
export var inputErrorWebsite = "singleLineForm-module--inputErrorWebsite--a1c8d";
export var singleLineFormContainer = "singleLineForm-module--singleLineFormContainer--5f035";